import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
    ResponsiveContainer,
    LineChart,
    PieChart,
    Pie,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    BarChart,
    Bar,
    Brush,
    ReferenceLine,
    Legend
} from "recharts";
import "./ChartView.css";
// import { Link } from "found";
import { Link } from "react-router-dom";

const CustomTooltip = ({ active, payload, label }) => {
    if (active) {
        return (
            <div className="custom-tooltip">
                <div>
                    <p className="post-title">{`${label}`}</p>
                </div>
                {payload ? (
                    <div>
                        <p className="score">{`Value : ${payload[0].value}`}</p>
                    </div>
                ) : null}
            </div>
        );
    }

    return null;
};

export default function ChartView(props) {
    const [meanSentimentTrend, setMeanSentimentTrend] = useState("Neutral");
    const tfidfData = props.tfidfData;
    const sentimentScore = props.sentimentScore;
    const sentimentTrend = props.sentimentTrend;
    const meanSentiment = props.meanSentiment;
    const sentimentPercent = props.sentimentPercent;

    useEffect(() => {
        if (meanSentiment > 0) {
            setMeanSentimentTrend("Positive");
        } else if (meanSentiment < 0) {
            setMeanSentimentTrend("Negative");
        } else {
            setMeanSentimentTrend("Neutral");
        }
    });
    return (
        <div className={`chartview-container`}>
            <div className={`chart-item-container`}>
                <h4>Term Frequency </h4>
                <p>Frequency of important terms in latest posts.</p>
                <ResponsiveContainer height={300} width="100%">
                    <BarChart
                        width={800}
                        height={300}
                        data={tfidfData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5
                        }}
                    >
                        <Bar dataKey="term" fill="#1a73e8" />
                        <Bar dataKey="value" fill="#1a73e8" />
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis hide="true" dataKey="term" />
                        <YAxis hide="true" />
                        <Brush dataKey="term" height={30} stroke="#8884d8" />
                        <Tooltip position={{ x: 20, y: 300 }} />
                    </BarChart>
                </ResponsiveContainer>
                <Legend />
            </div>

            <div className={`chart-item-container sentiment-chart`}>
                <h4> Sentiment Trend </h4>
                <p>Posts that are positive, negative or neutral.</p>
                <ResponsiveContainer height={300} width="100%">
                    <LineChart
                        width={800}
                        height={300}
                        data={sentimentScore}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5
                        }}
                    >
                        <Line
                            type="monotone"
                            dataKey="sentiment"
                            stroke="#1a73e8"
                        />
                        <CartesianGrid stroke="#eee" />
                        <XAxis hide="true" dataKey="postTitle" fill="#1a73e8" />
                        <YAxis hide="true" />
                        <Tooltip
                            content={<CustomTooltip />}
                            position={{ x: 10, y: 300 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
                <div className={`chart-sub-category`}>
                    <p>
                        The percentage of posts that are positive, negative or
                        neutral.
                    </p>

                    <ResponsiveContainer height={300} width="100%">
                        <PieChart width={400} height={400}>
                            <Pie
                                dataKey="value"
                                isAnimationActive={true}
                                data={sentimentPercent}
                                cx={200}
                                cy={200}
                                outerRadius={80}
                                fill="#1a73e8"
                                label="score"
                            />
                            <Tooltip />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
                <div>
                    <p>
                        &#9725; Positive: {sentimentPercent[0].value}% &nbsp;
                        &#9725; Neutral: {sentimentPercent[2].value}% &nbsp;
                        &#9725;Negative: {sentimentPercent[1].value}%
                    </p>
                    <p>
                        {" Overall Sentimental Trend: "}
                        <strong>{meanSentimentTrend}</strong>
                    </p>{" "}
                </div>

            </div>

            <p className={`analyse-short-description`}>
                Generated with{" "}
                <Link
                    target="_blank"
                    className={`feedgram-link`}
                    to="/topic-analysis"
                >
                    Feedgram Anvanced Topic Analysis.
                </Link>
            </p>
        </div>
    );
}
